import { extend, $ } from './HelperFunctions'

export class FocusStyle {
  constructor (settings, selectors, classes) {
    this.settings = extend({}, settings)

    this.selectors = extend({
      focusElements: 'a, button, input, textarea',
      isFocus: '.is--focus'
    }, selectors)

    this.classes = extend({
      isFocus: 'is--focus'
    }, classes)
  }

  init () {
    this.addEvents()
  }

  addEvents () {
    document.addEventListener('keyup', (event) => {
      const keyEvent = event || window.event

      // Tab
      if (keyEvent.key === 'Tab') {
        this.removeFocus()

        $(':focus').classList.add(this.classes.isFocus)
      }
    })

    $('body').addEventListener('click', (event) => {
      if (!event.target.classList.contains(this.classes.isFocus)) {
        this.removeFocus()
      }
    })
  }

  removeFocus () {
    const FocusElement = $(this.selectors.isFocus)
    if (FocusElement) {
      FocusElement.classList.remove(this.classes.isFocus)
    }
  }
}

export default FocusStyle
